export default "<spec-app-type13-code-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type13-code-table>\n";